<template>
  <el-form :model="form" ref="form" :rules="rules">
    <AutoForm :autoForm="form" ref="autoForm1" :labelWidth="320"></AutoForm>
    <el-form-item>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Keyboard from "@/components/keyboard/index.vue";
import { ElNotification } from "element-plus";
import AutoForm from "@/components/autoForm/index.vue";

export default {
  name: "Page",
  components: { AutoForm, Keyboard },
  data() {
    return {
      rules: {
        days: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
      form: [],
    };
  },
  methods: {
    async submit() {
      try {
        // console.log(v.$refs.form.validate);
        let valRes = await this.$refs.autoForm1.$refs.form.validate();
        console.log(valRes);
      } catch (err) {
        console.log("err autoForm1");
        console.log(err);
        return;
      }
      // return;
      try {
        let res = await this.$myRequest({
          url: "/post-warning-settings",
          method: "post",
          data: this.form,
        });
        ElNotification({
          title: "提示",
          message: "操作成功",
          type: "success",
        });
        this.init();
      } catch (err) {
        console.log("save err");
        console.log(err);
      }
    },
    async init() {
      // debugger;
      try {
        let res;
        res = await this.$myRequest({
          url: "/get-warning-settings",
          method: "get",
          data: {},
        });
        this.form = res.data.data;
      } catch (err) {
        console.log("err form init");
        console.log(err);
      }
    },
  },
  mounted() {
    // console.log(this.$route.path.split("/")[3]);
    console.log("param form mounted");
    this.init();
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
